export enum Languages {
  FRENCH = 'fr-CA',
  ENGLISH = 'en-CA',
}
